import { SelectOption } from '../../../../model/selectOption'
import { WbsSearchConditionCheckBoxPopper } from './WbsSearchConditionCheckBoxPopper'
import { Placement } from 'react-overlays/cjs/usePopper'
import { TextMatchCondition } from '../../../../../domain/value-object/WbsItemSearchConditionV2Vo'

type StandardCheckBoxProps = {
  open: boolean
  anchorEl: Element | undefined
  options: SelectOption[]
  value: string[] | undefined
  onChange: (newValue: string[] | undefined) => void
  offset?: number
  placement?: Placement | undefined
  maxHeight?: string
  triState?: false
}

type TriStateCheckBoxProps = {
  open: boolean
  anchorEl: Element | undefined
  options: SelectOption[]
  value: TextMatchCondition[] | undefined
  onChange: (newValue: TextMatchCondition[] | undefined) => void
  offset?: number
  placement?: Placement | undefined
  maxHeight?: string
  triState: true
}

type CheckBoxProps = StandardCheckBoxProps | TriStateCheckBoxProps

const WbsItemSearchCheckboxSelectConditionPopper = (props: CheckBoxProps) => {
  if (props.triState) {
    return (
      <WbsSearchConditionCheckBoxPopper
        triState={true}
        open={props.open}
        anchorEl={props.anchorEl}
        options={props.options}
        value={props.value}
        onChange={props.onChange}
        offset={props.offset}
        placement={props.placement}
        maxHeight={props.maxHeight}
      />
    )
  }
  return (
    <WbsSearchConditionCheckBoxPopper
      open={props.open}
      anchorEl={props.anchorEl}
      options={props.options}
      value={props.value}
      onChange={props.onChange}
      offset={props.offset}
      placement={props.placement}
      maxHeight={props.maxHeight}
    />
  )
}

export default WbsItemSearchCheckboxSelectConditionPopper
